import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './GridCol.module.scss.js';

var _excluded = ["className"];
var GridCol = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
  var prefix = 'col';
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (breakpoint) {
    var propValue = props[breakpoint];
    delete props[breakpoint];
    var span;
    var offset;
    var order;
    if (typeof propValue === 'object' && propValue != null) {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }
    var infix = breakpoint !== 'xs' ? "-" + breakpoint : '';
    if (span) {
      spans.push(span === true ? style["" + prefix + infix] : style["" + prefix + infix + "-" + span]);
    }
    if (order != null) classes.push(style["order" + infix + "-" + order]);
    if (offset != null) classes.push(style["offset" + infix + "-" + offset]);
  });
  if (!spans.length) {
    spans.push(style[prefix]); // just plain 'col'
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref,
    className: cx.apply(void 0, [className].concat(spans, classes))
  }));
});
var colSize = PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string, PropTypes.oneOf(['auto'])]);
var stringOrNumber = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
var column = PropTypes.oneOfType([colSize, PropTypes.shape({
  size: colSize,
  order: stringOrNumber,
  offset: stringOrNumber
})]);
var GridColPropTypes = {
  /**
  * The number of columns to span on extra small devices
  */
  xs: column,
  /**
  * The number of columns to span on small devices
  */
  sm: column,
  /**
  * The number of columns to span on medium devices
  */
  md: column,
  /**
  * The number of columns to span on large devices
  */
  lg: column,
  /**
  * The number of columns to span on extra large devices
  */
  xl: column,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
GridCol.propTypes = GridColPropTypes;
GridCol.displayName = 'GridCol';

export { GridColPropTypes, GridCol as default };
//# sourceMappingURL=GridCol.js.map
